import React, {useEffect, useState} from 'react';
import { withFormik } from 'formik';
import {useDispatch, useSelector} from 'react-redux';
import logo from '../../../assets/logo.png';
import validationSchema from './validationSchema';
import { IFormValues, IFormProps, FormProps } from './types';
import LoadingOverlay from '../../../components/LoadingOverlay';
import FormField from '../../../components/Forms/Input';
import { Row, Col } from './styles';
import { Form } from '../../../styles/forms';
import { Button } from '../../../styles/buttons';
import { Link, LinkGroup } from '../../../styles/links';
import {
  Container,
  Box,
  Image,
  Span,
} from '../../../styles/_layouts/Default';
import {IConfigData} from "../../../store/config/types";
import {setConfig} from "../../../store/config/action";

const InnerForm = (props: FormProps) => {
  const { handleSubmit, loading } = props;
  const dispatch = useDispatch();

  // Lê a config do parceiro de forma síncrona já na inicialização do estado.
  // Fazer isso aqui (e não num useEffect) garante que o primeiro render já use
  // o logo do parceiro, evitando o flash do logo da Valori — problema visível
  // principalmente no mobile, onde a imagem remota do parceiro demora a baixar.
  const [cachedConfig] = useState<IConfigData | null>(() => {
    const domain = window.location.hostname;
    return JSON.parse(localStorage.getItem(`config_${domain}`) as string);
  });
  const logoUrl = cachedConfig?.linkImagem ?? "";

  useEffect(() => {
    if (cachedConfig) {
      dispatch(setConfig(cachedConfig));
    }
  }, [cachedConfig, dispatch]);

  return (
    <Container>
      <Row>
        <Col>
          <Box>
            <LoadingOverlay relative show={loading} />
            <Image src={logoUrl || logo} alt="Logotipo" />
            <Form onSubmit={handleSubmit} noValidate>
              <FormField
                name="email"
                type="email"
                label="E-mail"
                placeholder="Digite seu e-mail"
                required
              />
              <FormField
                name="password"
                type="password"
                label="Sua senha"
                placeholder="Digite sua senha"
                required
              />
              <LinkGroup style={{ textAlign: 'center' }}>
                <Span>Esqueceu sua senha? </Span>
                <Link to="/esqueci-minha-senha">Clique aqui.</Link>
              </LinkGroup>
              <LinkGroup>
                <Link to="/politica-privacidade">Política de privacidade.</Link>
              </LinkGroup>
              <Button htmlType="submit">
                Entrar
              </Button>
            </Form>
          </Box>
        </Col>
      </Row>
    </Container>
  );
};

const SignForm = withFormik<IFormProps, IFormValues>({
  mapPropsToValues: () => ({
    email: '',
    password: '',
  }),
  validationSchema,
  handleSubmit: async (values, { props }): Promise<void> => {
    await props.onSignInFormSubmit(values);
  },
})(InnerForm);

export default SignForm;
